import { Theme } from "@mui/material";

export const mediaThumbnailStyling = (theme: Theme) => ({
    width: theme.spacing(4),
    height: theme.spacing(4),
    objectFit: "contain",
    cursor: "pointer",
    borderRadius: theme.spacing(1),
});

export const mediaBorderStyling = (theme: Theme) => ({
    border: `1px solid ${theme.palette.divider}`,
});

export const fileIconStyling = (theme: Theme) => ({
    width: theme.spacing(3.5),
    transform: `translateY(${theme.spacing(0.25)})`,
    objectFit: "contain",
    cursor: "pointer",
    borderRadius: theme.spacing(1),
});

export const gridMediaThumbnailStyling = (theme: Theme) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    objectFit: "cover",
    border: "none",
    borderRadius: "0",
    borderTopLeftRadius: `calc(${theme.spacing(2)} - 1px)`,
    borderTopRightRadius: `calc(${theme.spacing(2)} - 1px)`,
    cursor: "zoom-in",
    zIndex: 1,
});
